import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import generics_es from "../translations/es/generics.json";
import generics_ca from "../translations/ca/generics.json";

i18n
  .use(initReactI18next)
  .init({
    interpolation: { escapeValue: false },
    lng: "ca",
    fallbackLng: "ca",
    resources: {
      ca: { generic: generics_ca },
      es: { generic: generics_es },
    },
  });

export default i18n;
